import { useConfig } from "../../hooks/useConfig";
import { charityLabel, charitySentence, pledgeText } from "../../lib/charity";
import { formatCad } from "./Ledger";
import {
  creatorShare,
  platformFee,
  pledgeCeiling,
  pledgeExample,
  tradersPay,
} from "../../lib/fees";
import { Transparency } from "./Transparency";

export function Pledge() {
  const { config } = useConfig();
  const first = config?.donations?.entries[0] ?? null;

  return (
    <section className="shell section section--ruled" id="pledge">
      <div className="split">
        <div className="stack stack-3">
          <p className="eyebrow">The pledge</p>
          <h2>
            {pledgeText(config)}, to {charityLabel(config)}.
          </h2>
        </div>
        <div className="stack stack-5">
          <p className="body">
            The base is one thing only: the creator's share of trading fees. Every trade pays a
            platform fee of {platformFee(config)} plus a creator tax the creator set once at launch.
            The creator tax goes to the creator wallet. Half of it is donated. The pledge holds for
            as long as the token trades.
          </p>
          <p className="body">
            Fees arrive in ETH. They are sold, and the money is donated in Canadian dollars every
            quarter. There is no minimum and no maximum: whatever the quarter produces is what gets
            split.
          </p>
          <p className="body">
            The total traders pay is {tradersPay(config)}, and the creator's share is{" "}
            {creatorShare(config)}. Half of that share is what gets donated, so the pledge is{" "}
            {pledgeCeiling(config)}. In money, {pledgeExample(config)}. If nothing trades, nothing
            is donated.
          </p>
          <p className="body">{charitySentence(config)}</p>
          {first ? (
            <p className="body pledge__first">
              <strong>First donation, already made:</strong> {formatCad(first.cad)} to {first.recipient} on{" "}
              {first.date}, {first.source.charAt(0).toLowerCase() + first.source.slice(1)}. {first.reference}.
              It is the first row of the ledger below.
            </p>
          ) : null}
          <p className="tiny">
            No donation receipts are available to buyers or claimants. The donation is made by the
            team, so any acknowledgement from the charity names the team and not you.
          </p>
        </div>
      </div>
      <Transparency />
    </section>
  );
}
